webpackJsonp([15],{

/***/ 828:
/***/ (function(module, exports) {

var map_data = [{
    "data": [{
        "name": "Borno",
        "properties": { "hc-key": "ng-bo" },
        "value": "",
        "path": "M759,-671C753,-677,749,-682,749,-683,749,-684,753,-689,759,-695,769,-706,769,-705,765,-722,764,-726,766,-729,775,-737,788,-748,793,-756,796,-770,798,-774,800,-780,802,-783,807,-788,807,-791,803,-805,801,-813,801,-818,802,-826,803,-832,805,-847,806,-859,807,-878,808,-883,814,-894L820,-906,816,-915C812,-922,812,-924,814,-930,816,-938,819,-941,842,-962,859,-978,861,-979,869,-979,879,-979,889,-983,894,-991,897,-995,899,-996,905,-996,911,-995,913,-993,928,-973,937,-961,947,-948,949,-944,951,-939,953,-926,955,-907,957,-890,959,-876,960,-875,962,-874,970,-871,979,-869,998,-865,1000,-863,995,-850,993,-842,992,-837,993,-826,993,-819,994,-811,995,-808,996,-805,995,-803,982,-794,968,-786,966,-785,959,-786,953,-787,952,-786,950,-782,948,-779,943,-772,938,-766,931,-757,929,-755,924,-755,916,-755,904,-752,898,-748,895,-746,893,-743,893,-738,893,-728,889,-714,884,-707L880,-701,871,-708C860,-716,857,-716,844,-710,838,-708,827,-703,818,-701,805,-696,802,-694,797,-688,792,-680,773,-661,770,-661,769,-661,764,-666,759,-671z"
    }, {
        "name": "Adamawa",
        "properties": { "hc-key": "ng-ad" },
        "value": "",
        "path": "M776,-434C776,-438,776,-443,776,-446,777,-450,776,-451,768,-455,763,-458,758,-461,756,-462,753,-464,752,-464,750,-461,747,-457,747,-457,743,-461,736,-468,737,-471,749,-484,763,-499,784,-541,782,-548,781,-550,777,-557,772,-564,768,-571,764,-578,764,-580,764,-586,759,-594,751,-599,742,-605,741,-608,748,-608,752,-608,769,-618,771,-622,772,-623,772,-629,773,-635,774,-650,778,-657,798,-675,811,-688,815,-690,830,-695,839,-699,849,-702,853,-703,858,-705,859,-705,867,-700,878,-692,882,-692,890,-701,897,-709,898,-710,901,-728,903,-741,903,-741,911,-743,922,-747,923,-745,918,-725,916,-716,913,-702,911,-695,908,-680,907,-678,897,-673L890,-669,891,-647,892,-626,881,-620C873,-617,869,-613,867,-609,865,-606,862,-600,860,-596,856,-590,855,-587,855,-570L855,-551L844,-543C816,-521,810,-516,809,-512,808,-510,808,-501,807,-492,807,-478,806,-474,800,-461,796,-452,791,-444,790,-443,788,-441,787,-437,787,-434,786,-430,785,-428,782,-428,778,-427,777,-429,776,-434z"
    }, {
        "name": "Taraba",
        "properties": { "hc-key": "ng-ta" },
        "value": "",
        "path": "M723,-341C720,-343,712,-349,705,-354,698,-359,688,-367,682,-373,670,-386,665,-387,659,-377,654,-369,651,-368,637,-372L626,-375,615,-364C605,-353,600,-351,598,-356,597,-359,606,-379,613,-387,617,-392,618,-395,618,-406,618,-421,617,-422,602,-439,591,-452,586,-454,571,-454,560,-454,560,-454,564,-458,566,-461,567,-466,568,-474L569,-487,575,-485C588,-483,627,-509,641,-530,647,-539,654,-541,664,-540,679,-538,684,-547,675,-564,670,-572,669,-577,669,-586L669,-598L681,-605C694,-613,695,-613,700,-609,702,-607,708,-605,717,-605,732,-603,736,-602,747,-591,753,-586,755,-582,755,-578,755,-574,758,-568,764,-560L774,-546,762,-523C753,-504,748,-497,739,-488,726,-475,725,-471,733,-460,740,-450,745,-447,751,-449,756,-451,762,-449,765,-446,765,-445,766,-441,766,-437,766,-433,768,-428,770,-424,773,-419,773,-418,771,-417,767,-415,766,-411,769,-402,773,-390,773,-390,765,-388,759,-386,756,-382,754,-370,750,-350,747,-344,740,-340,732,-335,730,-335,723,-341z"
    }, {
        "name": "Gombe",
        "properties": { "hc-key": "ng-go" },
        "value": "",
        "path": "M708,-615C704,-616,700,-618,700,-618,700,-618,700,-622,701,-626,702,-635,702,-635,692,-645,682,-655,682,-656,685,-659,688,-662,688,-666,688,-678L687,-693,672,-701C664,-705,657,-710,656,-711,656,-712,657,-715,659,-717,664,-722,669,-734,669,-740,669,-746,670,-747,680,-744,690,-741,693,-742,696,-749,699,-757,703,-762,707,-762,708,-762,714,-759,720,-755,728,-749,730,-745,734,-736,736,-730,738,-720,739,-714,739,-708,741,-702,743,-701,746,-698,746,-694,741,-688,737,-683,737,-682,740,-679,741,-676,746,-671,751,-668,761,-659,764,-652,764,-641,764,-627,760,-622,743,-617,727,-611,719,-611,708,-615z"
    }, {
        "name": "Bauchi",
        "properties": { "hc-key": "ng-ba" },
        "value": "",
        "path": "M626,-769C621,-768,615,-768,610,-772,604,-776,599,-781,600,-790,601,-797,598,-802,591,-805,590,-805,588,-806,588,-808,588,-811,590,-812,591,-813,600,-816,608,-821,616,-825,624,-829,629,-835,628,-845,627,-849,628,-854,628,-859,628,-863,630,-866,634,-867,642,-869,649,-870,656,-874,659,-876,661,-875,662,-871,668,-853,675,-836,682,-818,686,-805,687,-792,682,-779,681,-775,682,-772,684,-770,686,-769,687,-767,688,-766,692,-762,692,-755,687,-752,686,-751,684,-751,682,-752,677,-754,672,-756,667,-755,664,-755,662,-754,661,-751,660,-747,660,-743,661,-740,663,-731,659,-726,653,-722,651,-721,650,-720,648,-720,646,-718,645,-716,647,-713,647,-713,647,-712,648,-712,649,-699,659,-697,668,-693,683,-687,687,-673,676,-661,671,-656,671,-655,677,-650,682,-645,687,-641,692,-635,695,-630,694,-621,689,-618,682,-613,675,-610,668,-606,665,-604,662,-605,659,-607,644,-619,627,-626,610,-635,604,-638,600,-635,599,-628,595,-613,581,-606,567,-611,562,-612,557,-615,553,-618,549,-620,547,-624,549,-629,552,-634,552,-640,552,-646,552,-650,550,-652,546,-650,542,-649,539,-648,535,-650,531,-651,530,-654,532,-657,535,-662,534,-668,534,-673,534,-678,532,-680,528,-680,524,-680,520,-680,516,-681,511,-681,509,-685,508,-689,506,-692,506,-695,509,-697,511,-698,512,-699,513,-700,519,-706,521,-713,517,-721,515,-726,515,-732,511,-736,510,-738,511,-740,513,-741,519,-747,525,-754,532,-759,539,-764,546,-762,553,-761,556,-760,559,-760,562,-761,566,-761,571,-763,573,-757,574,-756,576,-756,577,-756,582,-756,586,-756,590,-756,597,-756,598,-756,598,-749,598,-744,598,-740,602,-735,608,-728,616,-727,626,-728,629,-729,631,-731,630,-734,630,-739,632,-743,636,-747,640,-750,641,-755,642,-760,642,-765,639,-768,634,-769,631,-769,629,-769,626,-769z"
    }, {
        "name": "Yobe",
        "properties": { "hc-key": "ng-yo" },
        "value": "",
        "path": "M749,-705C747,-708,747,-713,748,-718,748,-722,748,-726,747,-727,746,-727,744,-733,741,-739,738,-749,736,-752,724,-761,711,-772,710,-772,704,-770,699,-769,697,-769,694,-771,691,-773,691,-775,692,-788,693,-796,693,-805,693,-808,691,-815,670,-872,666,-880,665,-883,663,-888,663,-891,663,-897,660,-901,647,-907,640,-911,636,-915,631,-922,628,-927,624,-931,622,-931,621,-931,614,-928,608,-924,601,-919,596,-916,595,-917,595,-917,598,-922,602,-928,610,-938,611,-939,625,-942,670,-954,682,-956,707,-956,729,-955,732,-954,742,-949,761,-939,776,-935,791,-935L804,-935L803,-927C802,-920,802,-917,805,-913,809,-907,809,-904,802,-891,797,-881,796,-877,796,-865,796,-857,795,-843,794,-835,789,-809,789,-807,793,-800,797,-794,797,-792,795,-789,791,-784,789,-779,785,-764,780,-750,780,-750,767,-741,760,-736,753,-730,753,-729,753,-727,754,-722,756,-716,757,-711,758,-706,758,-704,756,-700,751,-701,749,-705z"
    }],
    value: "Population",
    name: "North East",
    states: {
        hover: {
            color: '#fff'
        }
    },
    dataLabels: {
        enabled: true,
        format: '{point.name}'
    }
}, {
    "data": [{
        "name": "Sokoto",
        "properties": { "hc-key": "ng-so" },
        "value": "",
        "path": "M151,-832C148,-836,147,-841,149,-851,150,-857,151,-859,154,-859,160,-859,165,-865,165,-871,165,-874,167,-879,168,-882,173,-890,172,-898,167,-904,165,-906,163,-912,162,-916,161,-924,160,-925,150,-927,137,-929,120,-936,115,-940,114,-942,112,-946,112,-949,112,-954,114,-958,125,-968L138,-981,168,-981C195,-981,198,-981,208,-986,231,-995,230,-995,246,-987,258,-981,265,-979,274,-978,297,-976,298,-976,307,-962,316,-949,317,-947,313,-943,310,-940,306,-940,287,-945,270,-949,270,-949,266,-946,261,-941,261,-938,269,-927,273,-922,275,-916,275,-914,275,-913,263,-905,250,-897,217,-878,217,-877,217,-864L217,-854L205,-853C198,-852,186,-850,177,-847,163,-842,161,-841,158,-835,157,-832,155,-829,155,-829,155,-829,153,-830,151,-832z"

    }, {
        "name": "Zamfara",
        "properties": { "hc-key": "ng-za" },
        "value": "",
        "path": "M281,-737C281,-750,281,-750,272,-762,266,-769,262,-776,262,-779,262,-782,261,-786,260,-789,258,-793,256,-794,243,-795,231,-795,228,-796,222,-801,216,-806,212,-807,205,-803,202,-801,194,-800,181,-800,164,-800,160,-800,155,-796,147,-791,144,-792,144,-799,144,-803,146,-806,153,-813,158,-818,164,-824,165,-827,167,-831,170,-834,173,-836,182,-840,200,-844,210,-844,224,-844,226,-846,227,-861L227,-873,252,-887C265,-895,279,-903,281,-906,286,-912,286,-919,278,-930,276,-934,274,-938,274,-938,275,-939,283,-937,292,-935L308,-930,316,-935,324,-939,333,-929C339,-924,345,-918,348,-916,353,-913,353,-912,355,-883,355,-867,356,-848,356,-840,356,-829,357,-824,360,-821,363,-818,363,-818,354,-812,338,-803,338,-803,338,-785,338,-769,338,-768,331,-757,323,-744,319,-741,311,-741,308,-741,301,-738,294,-733L281,-724z"
    }, {
        "name": "Kebbi",
        "properties": { "hc-key": "ng-ke" },
        "value": "",
        "path": "M150,-659C142,-671,143,-677,155,-696,161,-704,165,-712,165,-714,165,-720,158,-724,146,-724,137,-724,133,-725,130,-728,126,-731,122,-732,107,-732,87,-732,85,-732,71,-745,56,-758,55,-760,65,-782L73,-801,74,-836,75,-871,92,-887C111,-907,114,-910,114,-921L114,-929,125,-924C131,-922,140,-918,144,-917,152,-915,153,-914,154,-909,155,-905,157,-901,160,-899L164,-896,160,-887C158,-882,156,-876,156,-874,156,-870,152,-867,146,-866,143,-866,141,-864,140,-858,136,-837,136,-837,141,-829,144,-825,146,-821,146,-820,146,-819,144,-815,140,-812,134,-806,134,-805,134,-793,135,-776,137,-775,150,-783,160,-789,161,-790,183,-791,196,-792,208,-793,211,-794,214,-795,216,-794,219,-791,222,-786,224,-786,245,-785,250,-785,251,-784,251,-778,251,-772,254,-767,266,-755,269,-752,272,-748,272,-747,272,-744,257,-737,252,-739,250,-739,242,-740,235,-741L221,-742,220,-751C219,-762,212,-770,204,-770,193,-770,164,-762,162,-759,156,-751,160,-743,174,-735,186,-728,187,-727,185,-717,184,-712,183,-711,179,-711,170,-711,168,-708,168,-695,168,-689,169,-680,170,-676,171,-670,171,-669,168,-669,164,-669,158,-662,158,-657,158,-650,156,-651,150,-659z"
    }, {
        "name": "Katsina",
        "properties": { "hc-key": "ng-kt" },
        "value": "",
        "path": "M354,-765C346,-774,346,-775,346,-784,347,-795,352,-801,363,-808,373,-814,374,-817,369,-824,366,-829,365,-835,364,-860,361,-917,361,-922,373,-922,381,-922,391,-925,414,-934L433,-941,448,-934C466,-924,510,-905,513,-905,516,-905,515,-902,512,-898,507,-894,504,-894,499,-900,488,-910,486,-911,467,-910,458,-909,449,-908,448,-907,444,-906,444,-891,448,-883,452,-874,450,-871,441,-868,434,-866,420,-858,420,-856,420,-855,420,-845,419,-832,419,-816,420,-809,422,-804L425,-798,416,-790C411,-785,407,-781,407,-780,407,-780,408,-777,411,-774,413,-770,414,-769,412,-767,411,-766,409,-767,406,-770,402,-776,391,-782,387,-780,386,-780,383,-777,382,-774,380,-770,377,-768,374,-768,368,-768,365,-766,363,-760,362,-756,362,-756,354,-765z"
    }, {
        "name": "Kano",
        "properties": { "hc-key": "ng-kn" },
        "value": "",
        "path": "M497,-709C495,-713,494,-719,494,-731,494,-750,492,-755,484,-755,481,-755,474,-760,464,-771,455,-780,447,-787,445,-787,443,-787,439,-784,434,-781,420,-770,414,-775,426,-788,430,-792,433,-797,433,-798,433,-799,432,-803,431,-808,429,-812,428,-822,428,-832,428,-850,431,-856,443,-859,453,-862,456,-864,458,-870,459,-873,461,-874,464,-873,466,-872,471,-873,475,-875,485,-880,488,-877,497,-863,500,-857,505,-851,508,-850,511,-849,514,-845,516,-839,519,-831,522,-829,533,-829L538,-829,535,-820C533,-815,532,-810,532,-809,532,-807,536,-804,542,-800,552,-793,553,-791,548,-780,545,-772,543,-770,537,-770,534,-770,527,-765,519,-757,511,-751,504,-745,503,-745,501,-745,502,-738,506,-727,510,-716,510,-709,507,-705,504,-702,501,-703,497,-709z"
    }, {
        "name": "Jigawa",
        "properties": { "hc-key": "ng-ji" },
        "value": "",
        "path": "M608,-741C606,-743,604,-748,604,-752,604,-757,603,-761,602,-761,598,-764,579,-768,568,-769,563,-770,557,-771,556,-772,555,-773,556,-777,558,-781,562,-792,562,-794,552,-803L543,-811,545,-822C549,-836,548,-838,536,-838,527,-838,526,-839,524,-843,521,-853,520,-854,514,-857,509,-860,504,-868,499,-880,498,-884,495,-885,490,-885,487,-886,483,-887,481,-888,478,-891,469,-888,469,-885,469,-881,468,-881,460,-886,456,-888,454,-891,454,-894,454,-898,456,-899,464,-901,476,-903,484,-903,486,-901,488,-896,503,-888,507,-888,510,-888,514,-890,519,-895L526,-902,559,-903,592,-904,606,-913C619,-921,621,-922,623,-919,627,-910,636,-903,644,-899,654,-895,656,-893,654,-887,653,-884,648,-881,637,-877L621,-871,620,-855C620,-845,619,-838,617,-836,614,-834,581,-817,574,-815,568,-813,570,-808,576,-804,580,-803,585,-799,588,-796,593,-792,593,-791,591,-786,589,-780,590,-778,599,-770,607,-763,615,-760,625,-760,633,-760,633,-756,625,-752,621,-749,620,-748,621,-743,622,-738,622,-737,616,-737,613,-737,609,-739,608,-741z"
    }, {
        "name": "Kaduna",
        "properties": { "hc-key": "ng-kd" },
        "value": "",
        "path": "M481,-568C470,-573,465,-573,463,-569,461,-564,457,-566,454,-573,451,-584,444,-587,430,-587,422,-587,416,-588,412,-591,408,-593,406,-593,403,-592,402,-590,398,-588,395,-586,390,-584,389,-584,386,-587,382,-591,382,-591,385,-598,388,-605,388,-607,385,-615,383,-621,383,-625,384,-631,385,-636,386,-641,385,-644,384,-648,383,-648,373,-648,363,-648,355,-651,355,-654,355,-655,359,-659,362,-664L369,-672,362,-677C358,-681,355,-684,355,-687,355,-694,353,-697,348,-700,340,-704,332,-704,326,-699,321,-695,321,-695,314,-698,304,-703,296,-702,292,-694,290,-690,289,-686,288,-685,288,-684,286,-684,284,-686,282,-688,281,-692,281,-701L281,-713L293,-720C299,-724,304,-729,305,-730,306,-731,309,-732,312,-732,320,-732,328,-736,334,-746,337,-750,341,-755,343,-757,347,-760,347,-760,353,-754,356,-751,360,-748,362,-747,366,-744,373,-748,373,-753,373,-755,375,-757,379,-758,383,-759,386,-762,387,-765,390,-770,391,-771,396,-769,398,-768,399,-765,399,-759,399,-750,402,-745,406,-745,408,-745,417,-751,427,-759,437,-767,446,-774,447,-774,447,-774,454,-767,462,-759,471,-749,477,-745,480,-745,484,-745,485,-744,485,-732,485,-716,487,-707,496,-692,505,-677,505,-673,499,-667,494,-662,493,-659,496,-654,498,-651,498,-649,496,-643,495,-639,494,-634,495,-631,496,-629,495,-624,492,-619,486,-608,486,-595,492,-588,499,-579,501,-574,498,-569,496,-564,492,-563,481,-568z"
    }],
    value: "Population",
    name: "North West",
    states: {
        hover: {
            color: '#fff'
        }
    },
    dataLabels: {
        enabled: true,
        format: '{point.name}'
    }
}, {
    "data": [{
        "name": "Plateau",
        "properties": { "hc-key": "ng-pl" },
        "value": "",
        "path": "M580,-504,575,-510,561,-508C543,-505,538,-507,535,-519,532,-529,533,-536,538,-543,540,-546,542,-551,541,-553,541,-557,540,-558,533,-558,520,-559,517,-560,515,-567,514,-571,510,-579,506,-585,496,-600,495,-604,500,-615,504,-624,506,-637,506,-654,507,-665,512,-671,521,-671,526,-671,527,-670,526,-667,525,-664,524,-658,523,-653L522,-643,532,-642C538,-641,542,-640,543,-640,543,-640,543,-634,542,-628,541,-620,541,-616,542,-614,546,-610,567,-601,572,-601,584,-601,604,-610,604,-616,604,-618,606,-620,607,-622,610,-626,611,-625,628,-616,638,-610,649,-603,652,-601,658,-596,659,-594,660,-581,661,-570,662,-565,666,-560,669,-556,670,-552,670,-551,669,-550,664,-549,659,-550L648,-550,637,-537C631,-530,624,-522,622,-519,616,-514,590,-498,586,-498,585,-498,582,-501,580,-504z"
    }, {
        "name": "Niger",
        "properties": { "hc-key": "ng-ni" },
        "value": "",
        "path": "M323,-497C318,-506,314,-512,307,-517,294,-528,288,-530,271,-531,257,-531,257,-532,250,-539,243,-546,241,-547,229,-548,216,-549,215,-550,206,-558,191,-573,185,-575,176,-568,170,-563,169,-563,169,-570,169,-576,163,-584,151,-592,147,-594,146,-596,146,-604,146,-614,143,-618,119,-635,101,-647,94,-650,80,-650L70,-650L71,-662,71,-674,78,-675C89,-676,90,-682,85,-703,83,-713,81,-722,81,-722,80,-723,90,-723,101,-723,118,-722,124,-721,129,-718,133,-716,139,-715,145,-715,150,-715,154,-714,154,-713,154,-711,150,-704,144,-697,133,-681,132,-674,139,-661,147,-646,150,-642,157,-642,164,-642,167,-646,167,-654,167,-658,169,-660,173,-661,181,-664,183,-669,180,-679,178,-683,177,-690,177,-694,177,-700,177,-701,183,-702,192,-704,194,-706,194,-720,194,-730,193,-734,190,-736,188,-738,186,-739,186,-739,183,-739,169,-750,169,-752,169,-755,195,-761,204,-760,210,-759,210,-759,211,-749,212,-735,215,-732,233,-732,241,-731,253,-731,260,-731L272,-731L272,-710C272,-686,274,-679,282,-674,289,-669,291,-670,296,-681,298,-687,301,-692,302,-692,303,-692,307,-691,312,-689,322,-685,324,-685,330,-691,335,-694,336,-695,339,-693,344,-690,346,-688,346,-682,346,-678,348,-676,351,-674L355,-671,350,-664C347,-660,344,-655,344,-653,344,-651,348,-647,355,-643,364,-637,366,-636,370,-638L375,-641,374,-630C373,-621,373,-617,375,-613,378,-608,378,-607,375,-601,372,-592,372,-589,376,-585,379,-582,379,-579,379,-574,377,-566,374,-565,367,-570,357,-577,337,-574,335,-565,335,-563,334,-544,335,-523,335,-489,335,-486,332,-485,330,-485,327,-488,323,-497z"
    }, {
        "name": "Kwara",
        "properties": { "hc-key": "ng-kw" },
        "value": "",
        "path": "M200,-462C194,-463,181,-464,171,-465L153,-466,149,-474C147,-478,140,-488,133,-496,119,-513,118,-518,128,-532,138,-545,136,-548,116,-551,105,-553,98,-555,95,-558,92,-561,89,-563,88,-563,88,-563,80,-556,72,-548,56,-533,47,-528,38,-528,25,-529,23,-528,14,-520,10,-515,6,-512,5,-513,5,-513,4,-519,4,-524,4,-535,5,-536,19,-544,29,-549,31,-553,34,-571,36,-583,38,-586,44,-594,48,-599,51,-605,51,-607,51,-610,53,-613,57,-615,65,-619,70,-626,71,-633,71,-638,72,-640,78,-641,81,-642,87,-642,90,-642,97,-640,136,-614,138,-609,138,-607,139,-601,139,-596,139,-586,139,-586,145,-584,153,-581,159,-574,161,-567,162,-560,168,-555,173,-555,175,-555,179,-557,182,-560L188,-565,200,-553,212,-540,226,-539C239,-538,241,-537,247,-530,254,-523,254,-523,267,-523,275,-523,281,-522,282,-522,283,-521,280,-507,277,-500,276,-497,274,-496,265,-496,255,-496,254,-497,246,-504,241,-509,236,-511,233,-511,225,-511,222,-509,223,-504,224,-501,223,-498,219,-496,216,-492,215,-490,216,-484,216,-480,218,-474,219,-471,220,-467,220,-465,219,-463,216,-460,215,-460,200,-462z"
    }, {
        "name": "FCT", // "Federal Capital Territory",
        "properties": { "hc-key": "ng-fc" },
        "value": "",
        "path": "M347,-499C345,-502,344,-507,344,-527,344,-540,345,-553,346,-557,348,-563,349,-564,353,-564,356,-564,362,-563,366,-560,377,-555,383,-557,387,-566,389,-571,392,-575,399,-578,408,-583,409,-583,410,-581,411,-579,409,-574,407,-570,404,-564,403,-560,403,-543,403,-519,403,-518,381,-510,372,-507,366,-503,364,-501,360,-495,352,-494,347,-499z"
    }, {
        "name": "Nasarawa",
        "properties": { "hc-key": "ng-na" },
        "value": "",
        "path": "M449,-455C427,-463,426,-463,399,-464,384,-464,370,-464,367,-463,363,-462,363,-462,363,-474,363,-482,364,-487,366,-490,368,-493,377,-498,387,-503,397,-507,406,-513,408,-515,410,-519,411,-524,411,-539,411,-557,411,-559,416,-568,420,-577,423,-579,427,-579,436,-580,443,-576,448,-566,454,-555,456,-553,463,-559,469,-563,474,-564,484,-559,495,-554,499,-554,503,-559,504,-561,506,-563,506,-562,506,-562,508,-559,510,-556,513,-552,515,-551,521,-551,525,-551,528,-551,529,-550,530,-549,528,-545,525,-541,521,-534,521,-533,523,-523,527,-503,536,-497,559,-498,569,-499,575,-498,575,-497,576,-496,574,-495,571,-496,562,-497,559,-492,559,-478,559,-468,558,-465,555,-463,550,-460,548,-460,531,-471,517,-479,516,-479,502,-479,488,-478,487,-478,479,-471L470,-463,472,-457C476,-449,476,-446,474,-447,473,-447,462,-451,449,-455z"
    }, {
        "name": "Benue",
        "properties": { "hc-key": "ng-be" },
        "value": "",
        "path": "M574,-331C568,-340,568,-341,561,-339,557,-338,551,-338,547,-338,541,-337,540,-338,536,-347,533,-352,530,-357,528,-357,527,-358,519,-359,510,-359,494,-359,491,-358,494,-351,496,-349,495,-347,491,-344,484,-338,478,-337,471,-341,467,-343,461,-344,454,-344,444,-343,444,-343,443,-336,442,-332,441,-330,439,-330,437,-330,436,-332,436,-341,436,-348,435,-352,433,-355,430,-358,429,-358,425,-355,419,-350,417,-351,413,-356,410,-361,410,-361,422,-372,432,-382,433,-384,433,-390,433,-394,431,-402,429,-409,423,-422,417,-450,420,-453,420,-453,435,-450,451,-444,477,-436,481,-435,484,-437,487,-440,487,-446,484,-457,482,-463,487,-467,498,-468,509,-470,516,-468,529,-461,539,-455,542,-451,542,-444,542,-436,546,-435,555,-439,561,-441,568,-443,576,-443,588,-443,588,-443,596,-434,601,-429,606,-421,609,-417,612,-409,612,-408,609,-400,607,-395,602,-386,598,-379,588,-365,588,-365,590,-354,592,-342,589,-327,584,-324,580,-321,580,-322,574,-331z"
    }, {
        "name": "Kogi",
        "properties": { "hc-key": "ng-ko" },
        "value": "",
        "path": "M336,-329C332,-335,332,-345,336,-350,338,-354,338,-359,338,-372L337,-389,328,-390C322,-390,318,-392,314,-396,310,-400,306,-402,299,-402,292,-403,290,-405,282,-413,278,-418,274,-423,274,-425,274,-429,266,-435,261,-435,253,-435,247,-440,246,-449,244,-455,243,-457,240,-458,237,-459,234,-463,230,-470,224,-483,224,-486,235,-501,235,-502,240,-499,244,-494,253,-487,254,-487,266,-487,273,-487,280,-488,282,-489,284,-490,286,-496,288,-503,289,-509,291,-514,292,-514,297,-516,307,-506,315,-491,320,-483,326,-476,328,-475,334,-473,340,-476,343,-483,345,-486,347,-488,347,-488,352,-488,354,-483,354,-468,354,-449,356,-446,367,-452,372,-455,377,-456,388,-456,405,-456,409,-453,411,-435,412,-428,415,-417,418,-409,426,-390,426,-388,415,-378,407,-370,406,-370,397,-371,389,-372,389,-372,381,-363,377,-358,374,-353,373,-352,372,-351,368,-350,364,-349,355,-348,344,-339,343,-332,341,-325,339,-324,336,-329z"
    }],
    value: "Population",
    name: "North Central",
    states: {
        hover: {
            color: '#fff'
        }
    },
    dataLabels: {
        enabled: true,
        format: '{point.name}'
    }
}, {
    "data": [{
        "name": "Ogun",
        "properties": { "hc-key": "ng-og" },
        "value": "",
        "path": "M135,-303C134,-307,132,-310,126,-314,120,-318,116,-322,114,-327,113,-332,110,-335,108,-335,105,-336,89,-336,70,-336L37,-335,33,-327C30,-320,29,-319,16,-316,9,-315,3,-314,3,-314,2,-314,2,-343,2,-377L1,-440,5,-441C8,-441,11,-439,13,-436,17,-431,17,-429,16,-420,15,-410,15,-409,25,-398,30,-391,36,-386,37,-386,39,-386,43,-388,48,-391,64,-403,78,-397,78,-378,78,-366,81,-364,97,-366,108,-367,109,-367,114,-361,119,-356,121,-355,131,-355,145,-355,147,-353,139,-343,131,-333,131,-326,139,-318,144,-313,144,-312,141,-305,138,-297,135,-296,135,-303z"
    }, {
        "name": "Oyo",
        "properties": { "hc-key": "ng-oy" },
        "value": "",
        "path": "M87,-375C87,-375,87,-380,87,-386,86,-398,84,-399,66,-405L53,-409,47,-403C43,-400,40,-397,38,-397,37,-397,34,-401,30,-405,26,-412,25,-415,25,-424,25,-440,20,-446,3,-451,0,-452,0,-454,1,-474L2,-495,10,-504C20,-515,30,-521,43,-521,53,-521,62,-527,78,-542,87,-552,89,-553,94,-547,96,-545,100,-544,104,-543,108,-543,114,-542,117,-541L122,-539,117,-532C115,-528,112,-522,112,-517,111,-509,111,-508,123,-495,131,-486,138,-475,142,-466,149,-450,149,-451,137,-445,131,-443,130,-443,128,-446,124,-452,123,-452,111,-443,101,-437,101,-436,102,-430,102,-426,102,-422,100,-420,97,-416,97,-415,102,-410,106,-406,107,-403,108,-393,109,-384,108,-380,106,-379,103,-377,88,-373,87,-375z"
    }, {
        "name": "Lagos",
        "properties": { "hc-key": "ng-la" },
        "value": "",
        "path": "M23,-308C33,-310,39,-314,42,-321L45,-326,75,-326C93,-327,105,-326,105,-325,105,-324,107,-320,110,-317,113,-313,116,-309,116,-308,116,-307,101,-306,65,-306,31,-306,17,-307,23,-308z"
    }, {
        "name": "Osun",
        "properties": { "hc-key": "ng-os" },
        "value": "",
        "path": "M119,-371C117,-375,116,-384,116,-393,116,-402,115,-409,114,-409,113,-410,112,-414,111,-419,109,-434,117,-441,127,-435,132,-432,153,-443,155,-450,157,-457,161,-458,175,-456,181,-455,187,-454,188,-453,188,-453,186,-450,183,-448,177,-443,177,-442,178,-429,179,-421,180,-413,182,-410,185,-402,185,-400,180,-398,177,-397,175,-394,175,-391,174,-385,173,-385,165,-384,155,-384,154,-382,151,-373L149,-366,135,-365,121,-365z"
    }, {
        "name": "Ondo",
        "properties": { "hc-key": "ng-on" },
        "value": "",
        "path": "M166,-275C156,-284,147,-291,147,-292,146,-293,148,-298,150,-303,155,-315,155,-316,148,-322,141,-329,141,-332,147,-338,150,-341,154,-348,156,-356,161,-373,162,-374,170,-374,180,-374,184,-377,184,-383,184,-390,189,-391,195,-386,201,-380,204,-382,208,-390,209,-394,211,-397,212,-397,213,-397,216,-394,218,-391,224,-382,227,-380,233,-385,237,-388,240,-393,244,-405,250,-422,252,-426,260,-426,263,-426,265,-424,267,-416,269,-410,270,-400,270,-392,270,-377,270,-377,257,-367,253,-364,252,-363,255,-357,258,-347,254,-339,246,-339,241,-338,239,-339,238,-343,235,-350,228,-354,219,-353,213,-353,212,-352,207,-343,205,-337,202,-329,202,-322,201,-311,200,-309,195,-304,187,-296,186,-292,194,-287,197,-286,200,-283,200,-282,200,-280,187,-260,186,-260,185,-260,177,-267,166,-275z"
    }, {
        "name": "Ekiti",
        "properties": { "hc-key": "ng-ek" },
        "value": "",
        "path": "M222,-400C216,-411,209,-412,204,-403,203,-400,201,-397,200,-397,198,-397,189,-418,189,-428,188,-438,188,-439,194,-446,200,-451,202,-452,210,-452,215,-452,220,-453,222,-454,225,-456,227,-455,229,-452,231,-450,234,-448,235,-448,236,-448,238,-447,238,-444,238,-442,239,-438,242,-436,246,-432,246,-431,243,-427,242,-425,238,-416,236,-408,233,-399,230,-392,229,-392,228,-392,225,-395,222,-400z"
    }],
    value: "Population",
    name: "South West",
    states: {
        hover: {
            color: '#fff'
        }
    },
    dataLabels: {
        enabled: true,
        format: '{point.name}'
    }
}, {
    "data": [{
        "name": "Enugu",
        "properties": { "hc-key": "ng-en" },
        "value": "",
        "path": "M407,-279C403,-281,397,-283,394,-283,387,-283,385,-286,376,-302,370,-314,370,-314,373,-320,378,-328,377,-332,371,-335L366,-338,372,-341C375,-343,381,-348,385,-352,389,-357,393,-361,394,-362,396,-363,400,-359,405,-352,412,-342,413,-342,419,-343,428,-345,429,-340,421,-332,415,-326,414,-324,415,-320,417,-311,420,-283,419,-279,418,-275,415,-275,407,-279z"
    }, {
        "name": "Anambra",
        "properties": { "hc-key": "ng-an" },
        "value": "",
        "path": "M340,-255C338,-256,339,-259,342,-272,345,-286,346,-291,344,-302,343,-314,343,-315,347,-318,349,-320,352,-324,353,-327,354,-334,354,-334,361,-330,367,-327,368,-325,365,-322,361,-318,361,-309,366,-302,368,-299,373,-291,376,-284,384,-272,383,-270,368,-270,360,-270,359,-269,357,-265,352,-254,347,-251,340,-255z"
    }, {
        "name": "Imo",
        "properties": { "hc-key": "ng-im" },
        "value": "",
        "path": "M350,-203C347,-206,346,-210,344,-223,343,-232,342,-240,343,-241,344,-242,346,-243,348,-243,354,-243,360,-248,363,-255,366,-261,368,-262,380,-263,387,-263,389,-263,391,-259,392,-256,393,-249,393,-242,393,-232,393,-229,388,-223,382,-215,382,-214,384,-209,385,-206,386,-203,385,-202,384,-200,377,-200,369,-200,358,-200,353,-201,350,-203z"
    }, {
        "name": "Abia",
        "properties": { "hc-key": "ng-ab" },
        "value": "",
        "path": "M384,-172C384,-176,388,-187,392,-193,395,-197,395,-200,394,-206,393,-214,394,-216,398,-221,402,-226,403,-228,403,-241,403,-253,402,-258,398,-265,393,-275,394,-276,408,-269,418,-264,434,-248,437,-241,439,-237,438,-224,436,-224,435,-224,432,-225,428,-227,420,-230,418,-228,409,-205,400,-183,400,-181,404,-177,409,-171,406,-169,394,-169,387,-169,384,-170,384,-172z"
    }, {
        "name": "Ebonyi",
        "properties": { "hc-key": "ng-eb" },
        "value": "",
        "path": "M429,-263C425,-268,425,-269,427,-274,430,-282,430,-305,428,-314,425,-324,426,-325,435,-322,444,-318,449,-321,451,-329,452,-334,453,-335,460,-335,464,-335,468,-333,470,-331,474,-326,479,-316,479,-312,479,-308,472,-292,467,-284,464,-280,463,-279,455,-280L447,-281,443,-272C437,-259,435,-258,429,-263z"
    }],
    value: "Population",
    name: "South East",
    states: {
        hover: {
            color: '#fff'
        }
    },
    dataLabels: {
        enabled: true,
        format: '{point.name}'
    }
}, {
    "data": [{
        "name": "Cross River",
        "properties": { "hc-key": "ng-cr" },
        "value": "",
        "path": "M497,-141C496,-142,494,-145,493,-148,493,-150,487,-157,482,-163,476,-170,469,-180,466,-187,458,-201,453,-207,448,-207,445,-207,445,-208,446,-221,447,-229,446,-238,445,-244,443,-253,443,-255,446,-262,450,-269,451,-270,458,-270,468,-270,472,-274,482,-294,490,-310,490,-313,484,-327,483,-330,484,-331,491,-334,496,-337,501,-340,503,-345,510,-355,522,-353,528,-340,534,-329,539,-327,551,-328,560,-329,561,-329,566,-325,574,-317,572,-313,544,-287,530,-274,518,-262,518,-260,517,-258,519,-253,522,-249,526,-241,527,-241,523,-236,521,-232,520,-228,520,-216L521,-201,513,-193C503,-182,502,-178,502,-158,502,-141,500,-136,497,-141z"
    }, {
        "name": "Akwa Ibom",
        "properties": { "hc-key": "ng-ak" },
        "value": "",
        "path": "M415,-145C415,-149,415,-155,415,-158,416,-161,416,-169,414,-176,412,-187,412,-188,417,-202,420,-210,423,-217,424,-218,426,-219,430,-213,432,-206,434,-202,436,-200,440,-199,450,-196,451,-195,459,-179,466,-166,468,-161,468,-153,468,-147,467,-142,466,-142,465,-141,454,-140,441,-140L417,-138z"
    }, {
        "name": "Rivers",
        "properties": { "hc-key": "ng-ri" },
        "value": "",
        "path": "M324,-127C323,-129,325,-135,328,-141,334,-153,333,-156,323,-159,318,-160,317,-160,317,-169,317,-177,318,-180,323,-185,326,-188,329,-193,330,-195,333,-200,333,-220,331,-221,328,-223,328,-232,330,-235,331,-237,333,-231,334,-222,336,-213,337,-204,337,-202,339,-196,350,-191,366,-190,380,-189,384,-186,377,-181,371,-177,371,-170,377,-164,381,-160,384,-160,394,-160L407,-160L407,-149C407,-143,407,-137,408,-134,408,-131,406,-130,394,-128,381,-125,380,-125,374,-129,366,-134,364,-134,350,-128,336,-122,326,-122,324,-127z"
    }, {
        "name": "Bayelsa",
        "properties": { "hc-key": "ng-by" },
        "value": "",
        "path": "M276,-118C270,-119,263,-124,259,-127,251,-135,238,-154,231,-169,225,-181,226,-184,235,-180,238,-178,243,-177,247,-176,252,-175,254,-175,260,-181,267,-187,269,-188,277,-188,282,-188,288,-189,291,-191,309,-203,313,-206,317,-210L322,-215,322,-205C322,-195,320,-191,311,-187,306,-184,306,-184,307,-172,309,-159,312,-152,318,-151,324,-149,324,-147,319,-143,316,-141,315,-139,315,-132L315,-124L306,-124C300,-123,298,-122,296,-119,294,-113,290,-113,276,-118z"
    }, {
        "name": "Edo",
        "properties": { "hc-key": "ng-ed" },
        "value": "",
        "path": "M274,-255C274,-265,270,-269,256,-276L249,-280,243,-276C239,-273,237,-272,234,-274,228,-277,223,-276,220,-272,217,-266,215,-267,214,-275,213,-281,211,-285,206,-289L198,-296,203,-302C207,-306,209,-311,210,-319,212,-343,225,-355,230,-337,231,-332,232,-331,241,-330,252,-329,257,-331,262,-342,265,-348,266,-352,265,-356,264,-362,265,-363,269,-366,275,-370,279,-380,279,-391L279,-401L285,-397C288,-395,293,-393,297,-393,302,-393,306,-392,312,-387,317,-382,322,-380,325,-380L331,-380L331,-368C331,-357,330,-355,326,-350,321,-344,321,-344,324,-335,328,-321,328,-320,318,-317,313,-315,308,-312,305,-310,303,-308,297,-307,291,-306,282,-305,280,-304,280,-301,279,-293,281,-286,288,-280L295,-274,290,-264C286,-254,279,-247,275,-247,274,-247,274,-251,274,-255z"

    }, {
        "name": "Delta",
        "properties": { "hc-key": "ng-de" },
        "value": "",
        "path": "M233,-190C223,-195,221,-197,222,-199,225,-207,225,-209,218,-214,201,-229,198,-233,196,-239,194,-242,194,-248,194,-252,196,-262,207,-275,207,-267,207,-263,211,-255,213,-255,214,-255,218,-257,222,-259,227,-263,229,-264,235,-263,240,-262,242,-263,245,-265,248,-268,250,-268,255,-266,263,-263,266,-257,265,-249,264,-242,267,-236,272,-236,282,-236,294,-247,300,-262,306,-276,305,-278,296,-285,288,-292,287,-296,294,-296,296,-296,304,-299,311,-303,332,-313,332,-313,334,-301,337,-288,336,-283,327,-253,316,-219,314,-217,298,-205,286,-197,283,-196,274,-196,266,-196,263,-195,258,-190,254,-187,250,-184,249,-184,247,-184,240,-187,233,-190z"
    }],
    value: "Population",
    name: "South South",
    states: {
        hover: {
            color: '#fff'
        }
    },
    dataLabels: {
        enabled: true,
        format: '{point.name}'
    }
}];
module.exports = map_data;

/***/ }),

/***/ 878:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_js_on_nigmap_regions_state_data__ = __webpack_require__(828);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_js_on_nigmap_regions_state_data___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_js_on_nigmap_regions_state_data__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'regionstatesMap',
  components: {},
  data: function data() {
    return {
      // lsData: JSON.parse(this.$ls.get('car_other_dataset')),
      mapPlotData: null,
      expandChart: false,
      dataAvailable: false,
      indicatorName: '',
      options: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        chart: {
          map: 'countries/ng/ng-all',
          borderColor: '#335cad',
          height: 438
        },

        colors: ['#2f7ed8', '#0d233a', '#8bbc21', '#910000', '#1aadce', '#492970', '#f28f43', '#77a1e5', '#c42525', '#a6c96a'],

        credits: {
          enabled: false,
          text: 'Map of Nigeria'
        },

        title: {
          text: 'Loading...',
          style: {
            fontSize: '16px',
            fontFamily: '"Open Sans", sans-serif',
            fontWeight: '600'
          }
        },

        subtitle: {
          text: "Loading...",
          style: {
            fontSize: '11px',
            fontFamily: '"Open Sans", sans-serif',
            fontWeight: 'normal'
          }
        },

        exporting: {
          csv: {
            dateFormat: '%Y-%m-%d'
          }
        },

        mapNavigation: {
          // enableDoubleClickZoomTo: true,
          enabled: true,
          buttonOptions: {
            verticalAlign: 'middle',
            align: 'right'
          }
        },

        legend: {
          enabled: false,
          layout: 'vertical',
          align: 'right'
        },
        colorAxis: {
          // min: 0,
          // max: 100,
          minColor: '#E6E7E8',
          maxColor: '#114663'
        },

        plotOptions: {
          map: {
            allAreas: false,
            mapData: __WEBPACK_IMPORTED_MODULE_1__assets_js_on_nigmap_regions_state_data___default.a, // Highcharts.maps['countries/ng/ng-all'],
            states: {
              hover: {
                color: '#BADA55'
              }
            },
            joinBy: "hc-key",
            dataLabels: {
              enabled: true,
              //format: '{point.name}',
              color: '#FFFFFF',
              formatter: function formatter() {
                if (this.point.value) {
                  return this.point.name;
                }
              }
            },
            tooltip: {
              headerFormat: '<b>{series.name}</b><br>',
              pointFormat: '{point.name}: <b>{point.value}</b>'
            }
          }
        },
        series: []
      }, 'exporting', {
        buttons: {
          contextButton: {
            menuItems: ["printChart", "separator", "downloadPNG", "downloadJPEG", "downloadPDF", "downloadSVG", "separator", "downloadCSV", "downloadXLS",
            //"viewData",
            "openInCloud"],
            symbol: 'download'
            // symbolStrokeWidth: 2,
            // symbolFill: '#330033',
            // symbolStroke: '#b3d4fc'
          }
        }
      })
    };
  },

  methods: {
    // for creating a color shade for states in same region
    // based on their values.
    shadeColor: function shadeColor(color, percent) {
      // convert color codes to integers with radix 16
      var R = parseInt(color.substring(1, 3), 16);
      var G = parseInt(color.substring(3, 5), 16);
      var B = parseInt(color.substring(5, 7), 16);

      // scale to 255
      R = parseInt(R * ((100 + percent) / 100));
      G = parseInt(G * ((100 + percent) / 100));
      B = parseInt(B * ((100 + percent) / 100));

      // readjust scale
      R = R > 0 ? R < 255 ? R : R - 255 : R + 255;
      G = G > 0 ? G < 255 ? G : G - 255 : G + 255; // (G>0)?G: R+255;
      B = B > 0 ? B < 255 ? B : B - 255 : B + 255;

      var RR = R.toString(16).length == 1 ? "0" + R.toString(16) : R.toString(16);
      var GG = G.toString(16).length == 1 ? "0" + G.toString(16) : G.toString(16);
      var BB = B.toString(16).length == 1 ? "0" + B.toString(16) : B.toString(16);

      return "#" + RR + GG + BB;
    },
    plotMap: function plotMap() {
      var _this = this;

      this.options.series = [];
      if (!this.mapPlotData) {
        return;
      }
      // var map = map_data;
      var tempMaxValue = [];
      var regionStatesMapProp = __WEBPACK_IMPORTED_MODULE_1__assets_js_on_nigmap_regions_state_data___default.a;
      console.log(__WEBPACK_IMPORTED_MODULE_1__assets_js_on_nigmap_regions_state_data___default.a);

      for (var value in this.mapPlotData) {
        if (this.mapPlotData.hasOwnProperty(value)) {
          tempMaxValue.push(this.mapPlotData[value]);
        }
      }
      var maxValue = Math.max.apply(null, tempMaxValue);
      var color = ["#83CFDB", "#EB928F", "#89D880", "#7D8ADE", "#F872A0", "#FFFF17"];
      // iterate over the 6 regions

      regionStatesMapProp.map(function (regionArray, index) {
        regionArray.color = color[index];
        regionArray.data.map(function (stateInRegion, index2) {
          stateInRegion.value = _this.mapPlotData[stateInRegion.name];
          if (maxValue > 100) {
            var percentageValue = stateInRegion.value / (Math.ceil(maxValue) + 100) * 100;
            stateInRegion.color = _this.shadeColor(color[index], -percentageValue);
          } else {
            stateInRegion.color = _this.shadeColor(color[index], -stateInRegion.value);
          }
        });
        _this.options.series.push(regionArray);
        //Check if the states has data
        for (var i in regionArray.data) {
          if (regionArray.data[i].value > 0) {
            _this.dataAvailable = true;
            break;
          } else {
            _this.dataAvailable = false;
          }
        }
        // regionsArray.data.map((obj,count) => {
        //   if(obj.value > 0){
        //     this.dataAvailable = true;
        //     break;
        //   }
        // })
      });
    }
  },
  computed: {
    computeMapData: function computeMapData() {
      var ngMapData = this.$store.getters.getCARngMapData;

      console.log(ngMapData);

      this.mapPlotData = ngMapData[0];
      this.options.title.text = ngMapData[1];
      this.indicatorName = ngMapData[1];
      this.options.subtitle.text = ngMapData[2] + '-' + ngMapData[3];
      //this.options.series[0].name = ngMapData[2];
      // this.plotMap()
      return "Nigeria Map";
    }
  },
  updated: function updated() {},
  mounted: function mounted() {
    // this.plotMap();
  },


  watch: {
    indicatorName: function indicatorName(val) {
      this.plotMap();
    }
  }
});

/***/ }),

/***/ 898:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(802)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"region_states.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 919:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(898);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(803)("5828e8cf", content, true, {});

/***/ }),

/***/ 945:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(919)
}
var Component = __webpack_require__(15)(
  /* script */
  __webpack_require__(878),
  /* template */
  __webpack_require__(958),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 958:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "hidden"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v(_vm._s(_vm.computeMapData))])]), _vm._v(" "), _c('div', {
    staticClass: "chart-wrapper",
    staticStyle: {
      "border": "0"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.dataAvailable),
      expression: "!dataAvailable"
    }],
    staticClass: "chart-has-no-data"
  }, [_c('img', {
    attrs: {
      "src": "static/img/no_data.svg"
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dataAvailable),
      expression: "dataAvailable"
    }],
    staticClass: "chart-stage"
  }, [_c('v-icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: ('Expand chart'),
      expression: "'Expand chart'",
      modifiers: {
        "top": true
      }
    }],
    staticClass: "expand-icon-highmap",
    on: {
      "click": function($event) {
        _vm.expandChart = true
      }
    }
  }, [_vm._v("zoom_out_map")]), _vm._v(" "), _c('highmaps', {
    ref: "highmaps",
    staticStyle: {
      "z-index": "0"
    },
    attrs: {
      "options": _vm.options
    }
  })], 1)])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "active": _vm.expandChart,
      "has-modal-card": ""
    },
    on: {
      "update:active": function($event) {
        _vm.expandChart = $event
      }
    }
  }, [_c('form', {
    attrs: {
      "action": ""
    }
  }, [_c('div', {
    staticClass: "modal-card"
  }, [_c('header', {
    staticClass: "modal-card-head",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v(_vm._s(_vm.indicatorName))])]), _vm._v(" "), _c('section', [_c('highmaps', {
    ref: "highmaps",
    staticStyle: {
      "z-index": "0"
    },
    attrs: {
      "options": _vm.options
    }
  })], 1), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('button', {
    staticClass: "button is-danger pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.expandChart = false
      }
    }
  }, [_vm._v("CLOSE")])])])])])], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/15.1f7a7dbca9f41062fe42.js